import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable, BehaviorSubject } from 'rxjs'
import { JwtHelperService } from '@auth0/angular-jwt'
import { NgxPermissionsService } from 'ngx-permissions'

@Injectable()
export class AuthService {
  jwt: any
  public isTokenRefreshing = new BehaviorSubject(false)

  constructor(
    private http: HttpClient,
    private permissionsService: NgxPermissionsService,
  ) {
    this.jwt = new JwtHelperService()
  }

  public setUser(token: string) {
    if (token) {
      localStorage.setItem('token', token)
      this.loadPermissions()
    }
  }

  public loadPermissions() {
    const userInfo = this.getUserInfo()

    if (userInfo) {
      const { permissions } = userInfo
      this.permissionsService.loadPermissions(permissions)
    }
  }

  public tokenExpDate(token = null): number {
    const { exp } = this.jwt.decodeToken(
      token ? token : localStorage.getItem('token'),
    )
    return exp
  }
  public getToken(): any {
    return localStorage.getItem('token') ? localStorage.getItem('token') : false
  }

  public isValidToken(): boolean {
    if (this.getToken()) {
      const { exp } = this.jwt.decodeToken(localStorage.getItem('token'))

      if (exp) {
        const currentTime = Math.floor(Date.now() / 1000)
        return !(currentTime >= exp)
      }
    }

    return false
  }

  public getUserInfo() {
    if (localStorage.getItem('token')) {
      try {
        const { user, sub, roles, permissions, termsAgreed } =
          this.jwt.decodeToken(localStorage.getItem('token'))
        return { ...user, email: sub, roles, permissions, termsAgreed }
      } catch (ex) {
        localStorage.clear()
      }
    }
    return null
  }

  public login(payload: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/auth/login`
    return this.http.post(url, payload)
  }

  public refreshToken(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/auth/refreshToken`
    return this.http.get(url)
  }

  public logout(): Observable<any> {
    return new Observable((observer) => {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      observer.next()
      observer.complete()
    })
  }

  public requestPasswordReset(email: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/profile/requestPasswordReset`
    return this.http.post(url, { email })
  }

  public passwordReset(payload): Observable<any> {
    const url = `${environment.API_ENDPOINT}/profile/resetPassword`
    return this.http.post(url, payload)
  }
}
